/**@global Admin Context */

/**
 * Get all Admin Data i.e. Users, Orders and any other collections - get all once and start SNAPSHOT listeners
 *
 *
 */
import React, { useContext, useEffect, useState } from 'react'
import { db } from '../config/Firebase'

import {
  collection,
  onSnapshot,
  orderBy,
  query,
  where,
} from 'firebase/firestore'
import { useUsers } from './UsersContext'
import { useAuthContext } from '../hooks/useAuthContext'
const AdminContext = React.createContext()

export const useAdmin = () => {
  return useContext(AdminContext)
}

const AdminProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [categories, setCategories] = useState()
  const [services, setServices] = useState('')
  const [selectedCategory, setSelectedCategory] = useState()
  const [radioButtons, setRadioButtons] = useState([])
  const [checkBoxes, setCheckBoxes] = useState([])
  const [error, setError] = useState('Test Error')
  const [quotes, setQuotes] = useState([])
  const [myQuotes, setMyQuotes] = useState([])
  const [messages, setMessages] = useState([])
  const [newMessages, setNewMessages] = useState([])
  const { loggedOnUser } = useUsers()
  const { user } = useAuthContext()
  const [search, setSearch] = useState([' '])
  const [selectedServ, setSelectedServ] = useState()
  const citiesOffered = ['London', 'Slough', 'Harrow', 'Birmingham']

  useEffect(() => {
    getServices()
    getCategories()
    getRadioButtons()
    getCheckBoxes()
    getQuotes()
    // getMyQuotes()
    getMessages()
  }, [])

  useEffect(() => {
    getMyQuotes()
  }, [loggedOnUser])

  // Admin Only
  const getCheckBoxes = async () => {
    const q = query(collection(db, 'checkBoxes'))
    await onSnapshot(
      q,
      (querySnapshot) => {
        let rcvdCheckBoxes = []
        querySnapshot.forEach((doc) => {
          rcvdCheckBoxes.push({ id: doc.id, ...doc.data() })
        })
        setCheckBoxes(rcvdCheckBoxes)
      },
      (err) => {
        console.log('ERROR SNAP: ', err)
        setError('Error getting Checkboxes')
      }
    )
    setLoading(false)
  }

  // Admin Only

  const getCategories = async () => {
    const q = query(collection(db, 'categories'), orderBy('name'))
    await onSnapshot(
      q,
      (querySnapshot) => {
        let rcvdCategories = []
        querySnapshot.forEach((doc) => {
          rcvdCategories.push({ id: doc.id, ...doc.data() })
        })
        setCategories(rcvdCategories)
        setSelectedCategory(null)
      },
      (err) => {
        console.log('ERROR SNAP: ', err)
        setError('Error getting Categories')
      }
    )
    setLoading(false)
  }
  // Admin Only

  const getServices = async () => {
    const q = query(collection(db, 'services'), orderBy('name'))
    await onSnapshot(
      q,
      (querySnapshot) => {
        let rcvdServices = []
        querySnapshot.forEach((doc) => {
          rcvdServices.push({ id: doc.id, ...doc.data() })
        })
        setServices(rcvdServices)
      },
      (err) => {
        console.log('ERROR SNAP: ', err)
        setError('Error getting Services')
      }
    )
    setLoading(false)
  }
  // Admin Only

  const getRadioButtons = async () => {
    const q = query(collection(db, 'radioButtons'))
    await onSnapshot(
      q,
      (querySnapshot) => {
        let rcvdRadioButtons = []
        querySnapshot.forEach((doc) => {
          rcvdRadioButtons.push({ id: doc.id, ...doc.data() })
        })
        setRadioButtons(rcvdRadioButtons)
      },
      (err) => {
        console.log('ERROR SNAP: ', err)
        setError('Error getting Radios')
      }
    )
    setLoading(false)
  }

  // getQuotes for Admin Users

  const getQuotes = async () => {
    const q = query(
      collection(db, 'quotes'),
      where('status', '==', 'New'),
      orderBy('created', 'desc')
    )
    await onSnapshot(
      q,
      (querySnapshot) => {
        let rcvdQuotes = []
        querySnapshot.forEach((doc) => {
          rcvdQuotes.push({ id: doc.id, ...doc.data() })
        })
        setQuotes(rcvdQuotes)
      },
      (err) => {
        console.log('ERROR SNAP: ', err)
        setError('Error getting Quotes')
      }
    )
    setLoading(false)
  }

  const getMyQuotes = async () => {
    const by = user && user.email
    const q = query(collection(db, 'quotes'), where('createdBy', '==', by))
    await onSnapshot(
      q,
      (querySnapshot) => {
        let rcvdQuotes = []
        querySnapshot.forEach((doc) => {
          rcvdQuotes.push({ id: doc.id, ...doc.data() })
        })
        // alert('rcvdQuotes', JSON.stringify(rcvdQuotes))
        setMyQuotes(rcvdQuotes)
      },
      (err) => {
        console.log('ERROR SNAP: ', err)
        setError('Error getting Quotes')
      }
    )
    setLoading(false)
  }

  // Admin Only

  const getMessages = async () => {
    const q = query(collection(db, 'commsSasi'), orderBy('createdAt', 'desc'))
    await onSnapshot(
      q,
      (querySnapshot) => {
        let rcvdMessages = []
        querySnapshot.forEach((doc) => {
          rcvdMessages.push({ id: doc.id, ...doc.data() })
        })
        setMessages(rcvdMessages)
        setNewMessages(rcvdMessages.filter((q) => q.status === 'new'))
      },
      (err) => {
        console.log('ERROR SNAP: ', err)
        setError('Error getting Quotes')
      }
    )
    setLoading(false)
  }

  const value = {
    categories,
    error,
    setError,
    services,
    radioButtons,
    checkBoxes,
    selectedCategory,
    setSelectedCategory,
    quotes,
    myQuotes,
    messages,
    newMessages,
    search,
    setSearch,
    selectedServ,
    setSelectedServ,
    citiesOffered,
  }

  return (
    <AdminContext.Provider value={value}>
      {!loading && children}
    </AdminContext.Provider>
  )
}

export default AdminProvider
